export default "__VITE_ASSET__Ijlg41tI__"